/* eslint-disable unicorn/no-array-for-each */
import InputField from '../InputField';
import RadioComponent from '../RadioComponent';
import SchoolFinder from '../SchoolFinder';
import TournamentFinder from '../TournamentFinder';
import TournamentEventDetails from '../TournamentEventDetails';
import TournamentEventForm from '../TournamentEventForm';
import CoachFinder from '../CoachFinder';
import SchoolInputCode from '../SchoolInputCode';
import SearchInputField from '../SearchInputField';
import SelectComponent from '../SelectComponent';
import ParkFinder from '../parkFinder';
import VenueAddressSearch from '../VenueAddressSearch';
import DateComponent from '../DateComponent';
import DuetDateComponent from '../DuetDateComponent';
import CheckboxComponent from '../CheckboxComponent';
import CounterComponent from '../CounterComponent';
import FileUploadComponent from '../FileUploadComponent';
import PlayerList from '../PlayerList';
import ContactNumber from '../ContactNumber';
import KeyPoints from '../KeyPoints';
import MentorFinder from '../MentorFinder';
import FormTable from '../Table';
import AffiliatedVenueSearchList from '../AffiliatedVenueSearchList';
import AuthorityFinder from '../AuthorityFinder';
import SessionPlayersList from '../SessionPlayersList';
import AddressFinder from '../AddressFinder';
import CheckoutComponent from '../CheckoutComponent';
import getAge from '../../utils/getAge';
import {
	extraCoachData,
	extraSchoolData,
	extraCountyData,
	extraCoachVenueSearchData,
	extraActivatorVenueSearchData,
	extraParkData,
	extraTournamentData,
	extraMentorData,
	extraAuthorityData,
	extraUniversityData,
	extraAddressData,
	extraNurseryData,
	extraCollegeData,
	extraTennisLeaderPrimaryVenueData
} from './data';
import { QuestionTypes } from './questionTypes';

const withQuestionData = (question, commonConfig, extras = {}) => ({
	data: {
		...question,
		...extras,
		...commonConfig
	}
});

export const coreQuestionRenderers = {
	[QuestionTypes.FileUpload]: (_ctx, question, container, commonConfig) =>
		new FileUploadComponent(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.Checkbox]: (_ctx, question, container, commonConfig) =>
		new CheckboxComponent(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.Counter]: (_ctx, question, container, commonConfig) =>
		new CounterComponent(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.Info]: (_ctx, question, container, commonConfig) =>
		new KeyPoints(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.Radio]: (ctx, question, container, commonConfig) =>
		new RadioComponent(container, {
			data: {
				answerField: ctx.data?.radioAnswerField || 'label',
				...question,
				...commonConfig
			}
		}),

	[QuestionTypes.Select]: (_ctx, question, container, commonConfig) =>
		new SelectComponent(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.DateComponent]: (_ctx, question, container, commonConfig) =>
		new DateComponent(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.DuetDateComponent]: (_ctx, question, container, commonConfig) =>
		new DuetDateComponent(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.SchoolSortCode]: (_ctx, question, container, commonConfig) =>
		new SchoolInputCode(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.CountySearch]: (_ctx, question, container, commonConfig) => {
		const ref = new SearchInputField(container, withQuestionData(question, commonConfig, extraCountyData));
		ref.dataMapping = (item) => ({
			firstLineText: item,
			dataKey: extraCountyData.dataKey,
			dataValue: item
		});
		ref.filterDataMapping = (item, event) => item === event[extraCountyData.dataKey];
		ref.searchInputMappingChange();
		return ref;
	},

	[QuestionTypes.SchoolSearch]: (_ctx, question, container, commonConfig) =>
		new SchoolFinder(container, withQuestionData(question, commonConfig, extraSchoolData)),

	[QuestionTypes.NurserySearch]: (_ctx, question, container, commonConfig) =>
		new SchoolFinder(container, withQuestionData(question, commonConfig, extraNurseryData)),

	[QuestionTypes.CollegeSearch]: (_ctx, question, container, commonConfig) =>
		new SchoolFinder(container, withQuestionData(question, commonConfig, extraCollegeData)),

	[QuestionTypes.AddressFinder]: (_ctx, question, container, commonConfig) =>
		new AddressFinder(container, withQuestionData(question, commonConfig, extraAddressData)),

	[QuestionTypes.Checkout]: (ctx, question, container, commonConfig) =>
		new CheckoutComponent(container, {
			data: {
				...question,
				...commonConfig,
				onSuccess: ctx.data?.checkoutSuccess,
				userDetails: ctx.data?.userDetails
			}
		}),

	[QuestionTypes.UniversitySearch]: (_ctx, question, container, commonConfig) =>
		new SchoolFinder(container, withQuestionData(question, commonConfig, extraUniversityData)),

	[QuestionTypes.TournamentSearch]: (_ctx, question, container, commonConfig) =>
		new TournamentFinder(container, withQuestionData(question, commonConfig, extraTournamentData)),

	[QuestionTypes.TournamentEventDetails]: (_ctx, question, container, commonConfig) =>
		new TournamentEventDetails(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.TournamentEventForm]: (_ctx, question, container, commonConfig) =>
		new TournamentEventForm(container, withQuestionData(question, commonConfig, extraTournamentData)),

	[QuestionTypes.ParkFinder]: (_ctx, question, container, commonConfig) =>
		new ParkFinder(container, withQuestionData(question, commonConfig, extraParkData)),

	[QuestionTypes.AffiliatedVenueSearchList]: (_ctx, question, container, commonConfig) =>
		new AffiliatedVenueSearchList(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.CoachVenueSearch]: (_ctx, question, container, commonConfig) =>
		new ParkFinder(container, withQuestionData(question, commonConfig, extraCoachVenueSearchData)),

	[QuestionTypes.ActivatorVenueSearch]: (_ctx, question, container, commonConfig) =>
		new ParkFinder(container, withQuestionData(question, commonConfig, extraActivatorVenueSearchData)),

	[QuestionTypes.TextArea]: (_ctx, question, container, commonConfig) =>
		new InputField(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.TextInput]: (_ctx, question, container, commonConfig) =>
		new InputField(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.ITTProviderSearch]: (_ctx, question, container, commonConfig) =>
		new InputField(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.CoachSearch]: (_ctx, question, container, commonConfig) =>
		new CoachFinder(container, withQuestionData(question, commonConfig, extraCoachData)),

	[QuestionTypes.VenueAddressSearch]: (ctx, question, container, commonConfig) =>
		new VenueAddressSearch(container, {
			data: {
				...question,
				...commonConfig,
				saveAddress: ctx.data?.saveAddress ?? true,
				restrictToGB: Boolean(question.restrictToGB ?? ctx.data?.restrictToGB)
			}
		}),

	[QuestionTypes.MentorFinder]: (_ctx, question, container, commonConfig) =>
		new MentorFinder(container, withQuestionData(question, commonConfig, extraMentorData)),

	[QuestionTypes.FormTable]: (_ctx, question, container, commonConfig) =>
		new FormTable(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.AuthorityFinder]: (_ctx, question, container, commonConfig) =>
		new AuthorityFinder(container, withQuestionData(question, commonConfig, extraAuthorityData)),

	[QuestionTypes.PlayerList]: (_ctx, question, container, commonConfig) =>
		new PlayerList(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.ContactNumber]: (_ctx, question, container, commonConfig) =>
		new ContactNumber(container, withQuestionData(question, commonConfig)),

	[QuestionTypes.ChildContactNumber]: (ctx, question, container, commonConfig) => {
		const ref = new ContactNumber(container, {
			data: {
				...question,
				...commonConfig,
				shouldReRenderOnStepChange: true
			}
		});
		ref.shouldRender = () => {
			const playerData = ctx.getAnswerByQuestionType(QuestionTypes.SessionPlayerList);
			if (!playerData) {
				return false;
			}
			let hasChild = false;
			Object.values(playerData).forEach((session) => {
				session.forEach((player) => {
					const age = getAge(player.dateOfBirth);
					if (age < 18) {
						hasChild = true;
					}
				});
			});
			return hasChild;
		};
		return ref;
	},

	[QuestionTypes.SessionPlayerList]: (_ctx, question, container, commonConfig) =>
		new SessionPlayersList(container, {
			data: {
				...question,
				...commonConfig,
				hasPerformActionOnload: true
			}
		}),

	[QuestionTypes.TennisLeaderPrimaryVenueSearch]: (_ctx, question, container, commonConfig) =>
		new ParkFinder(container, withQuestionData(question, commonConfig, extraTennisLeaderPrimaryVenueData))
};
